/*global translate*/
import { connect } from 'react-redux'
import React, { Component } from 'react'
global.isclient && require('./rxNewUserInfo.css')
const { rxaget, stringToColour, rxChangeSlug, changeColorSVG } = global.rootRequire('classes/ulti')
const { checkNameUser, checkBlock, changeColorAva, textAva } = global.rootRequire('classes/chat')
const rxio = global.rootRequire('classes/socket').default
const { chooseGroupAction, clickCall, updateGroupsDraft, netaGroupsUpdate } = global.rootRequire('redux')

const chatDB = global.rootRequire('classes/indexedDB').default
const workerUnread = global.rootRequire('classes/globalUnread')

class RxInfoUser extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      userInfo: {},
      infoUserId: 0,
      partnerProfile: {}//2: customer, 1: sale, 0: no info
    }

    this.user = rxaget(this.props, 'netaauth.user', {})

    this.flagBtnChat = false

    this.arrDefaultStaff = [{ name: 'Email', key: 'email' }, { name: 'Phone', key: 'tel' }, { name: 'Department', key: 'department' }, { name: 'Work Place', key: 'work_place' }]
    this.arrDefaultCustomer = [{ name: 'Customer Id', key: 'customer_id' }, { name: 'Your Mission', key: 'task' }]
  }

  componentDidMount() {
    if (rxaget(this.props, 'infoUserId', 0) !== rxaget(this.state, 'infoUserId', 0)) {
      let infoUserId = rxaget(this.props, 'infoUserId', 0)
      if (infoUserId !== 0) {
        chatDB.users.get(Number(infoUserId)).then(userInfo => {
          this.setState({
            userInfo: userInfo,
            partnerProfile: {}
          }, () => {
            this.fetchProfile()
          })
        })
      }


      // let userInfo = this.props.userInfo
      // let ownerInfo = this.props.ownerInfo
      // let userClick_group = this.props.userClick_group
      // let userid = this.props.ownerInfo.id
      // let partner_id = userInfo.id

      // this.setState({
      //   userInfo: userInfo, 
      //   ownerInfo: ownerInfo,
      //   userClick_group:userClick_group,
      //   userid:userid
      // })    
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (rxaget(nextProps, 'infoUserId', 0) !== rxaget(this.state, 'infoUserId', 0)) {
      let infoUserId = rxaget(nextProps, 'infoUserId', 0)

      if (infoUserId !== 0) {
        chatDB.users.get(Number(infoUserId)).then(userInfo => {
          this.setState({
            userInfo: userInfo,
            partnerProfile: {}
          })
        })
      }
    }
  }

  closePopupInfoUser() {
    setTimeout(() => {
      this.props.closePopupInfoUser()
    }, 500)
  }


  createNewChat(user, funcCallback) {
    let userOwner = this.user
    let userid = userOwner.id
    let partner_id = Number(user.id)

    const params = {
      'type': 3,
      'owner_uin': userOwner.id,
      'name': '',
      'avatar_url': '',
      'occupants_uins': [userid, partner_id],
      'sender_name': userOwner.name
    }

    try {
      let params = {
        'type': 3,
        'occupants_uins': [userid, partner_id]
      }

      let createdAt = new Date().getTime() * 1000

      if (!this.flagBtnChat) {
        this.flagBtnChat = true
        rxio.checkGroup(params, (data) => {
          let last_message = {
            'attachments': "",
            'created_at': createdAt
          }

          if (data && data.group) {

            let group = data.group
            let group_id = data.group.group_id

            chatDB.groups.get(group_id.toString()).then(groupObj => {
              if (!groupObj) {
                group.last_message = last_message
                group.flagDraf = "1"

                let newnameuser = checkNameUser(user) || ''
                group['fullnamegroup'] = (user.full_name) ? user.full_name : (newnameuser) ? newnameuser : user.phone || ''
                group.group_fullname = group['fullnamegroup']

                this.props.netaGroupsUpdate(group.group_id, group)
                this.props.chooseGroupAction(group)

                this.closePopupInfoUser()
              } else {
                this.props.chooseGroupAction(groupObj)

                setTimeout(() => {
                  if (!funcCallback) {
                    this.closePopupInfoUser()
                  } else {
                    this.closePopupInfoUser()
                    funcCallback(groupObj)
                  }
                }, 500)


              }
            })

          } else {
            let objGroup = JSON.parse(JSON.stringify({
              'admin_uins': [userid],
              'avatar_url': user.profile_url || '',
              'background': "",
              'blocked_uins': [],
              'count_unread': 0,
              'created_at': createdAt,
              'creator_uin': userid,
              'description': "",
              'group_fullname': (user.full_name) ? user.full_name : user.phone || '',
              'group_id': partner_id,
              'last_active_messages': [],
              'last_message': last_message,
              'last_message_id': "",
              'last_messages': [],
              'last_sos_messages': [],
              'locations': [],
              'mode': 0,
              'muted_uins': [],
              'name': "",
              'occupants_uins': [partner_id.toString(), userid.toString()],
              'owner_uin': userid,
              'partner_id': partner_id,
              'pinned_messages': [],
              'pinned_uins': [],
              'received_list': [],
              'removed_uins': [],
              'secrets': [],
              'seen_list': [],
              'status_list': [],
              'type': 3,
              'unread_cnt': 0,
              'updated_at': createdAt,

              'timestamp': createdAt,
              'flagDraf': '1',
              'flagPin': '0',
              'last_sort': '110' + createdAt
            }))

            if (funcCallback) {
              alert(translate('Please create a chat first'))
            }

            this.props.updateGroupsDraft(objGroup, partner_id)
            this.props.netaGroupsUpdate(objGroup.group_id, objGroup)
            this.props.chooseGroupAction(objGroup)
            this.closePopupInfoUser()
          }
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  async fetchProfile() {
    try {
      let partnerUser = this.state.userInfo
      if (this.user && partnerUser && this.user.phone && partnerUser.phone && partnerUser.phone !== "") {
        let checked = true

        let checkContact = await chatDB.contacts.get(partnerUser.phone)

        // my is staff
        let partnerIsStaff = (partnerUser.phone.indexOf('ipa') !== -1 || partnerUser.phone.indexOf('pti') !== -1 || /^.{3}\\/.test(partnerUser.phone)) ? true : false

        if (checked) {
          let api_profile = global.rxu.config.base_api_neta + '/api/users/profile/' + encodeURI(partnerUser.phone)
          let token = rxaget(this.user, 'token', '')

          fetch(api_profile, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'TC-Token': token,
              Connection: 'Keep-Alive',
              'Accept-Encoding': 'gzip'
            }
          }).then(res => res.json()).then((json) => {
            if (json && json.username) {
              let partnerProfile = { type: 0, Id: '', department: '', email: '', full_name: '', tel: '', username: '', work_place: '', customer_id: '' }
              partnerProfile = { ...partnerProfile, ...json };

              if (json.user_type && json.user_type === 1) {
                partnerProfile['type'] = 1
              } else {
                partnerProfile['type'] = 2
              }
              // if (partnerIsStaff && (rxaget(json, "customer_id", "") === "")) {
              //   partnerProfile['type'] = 1 // staff
              // } else {
              //   partnerProfile['type'] = 2 // customer   
              // }

              this.setState({
                partnerProfile: partnerProfile
              })
            }
          }).catch(error => {
            console.log("fetch Profile error")
          })
        }
      }
    } catch (e2) {
      console.log(e2)
    }
  }

  onClickStartCall(typeCall, userInfo) {
    this.createNewChat(userInfo, (group) => {
      if (group) {
        this.props.clickCall(typeCall, {
          group_id: rxaget(group, 'group_id', ''),
          type: rxaget(group, 'type', 0),
          occupants_uins: rxaget(group, 'occupants_uins', [])
        })
      }
    })
  }

  render() {
    let userInfo = this.state.userInfo || {}

    return (
      <div className='avatarClick_rectangle'>
        <div className='avatarClick_rectangle_1'></div>
        <div className='avatarClick_rectangle_2_1'>
          <div className='avatarClick_title_place'>
            <div className='avatarClick_title'>{translate('Account information')}</div>
            <div className='avatarClick_closeIcon' onClick={() => this.props.closePopupInfoUser()}>
              <img className='icon-basic-up filter_img_class' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} alt='' />
            </div>
          </div>
          <div className='avatarClick_avatarPlace'>
            <div className='avatarClick_avatar_userinfo'>
              {(userInfo && userInfo.profile_url) ?
                <img src={`${global.rxu.config.cdn_endpoint}` + userInfo['profile_url']} alt='profile_url' className='images-static' onError={(e) => { e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} />
                :
                <span className='account-ava-span' style={{ background: `${changeColorAva(rxaget(userInfo, 'id', '').toString())}` }}> {textAva(rxChangeSlug(checkNameUser(userInfo), true))} </span>
              }
            </div>
          </div>
          <div className='avatarClick_userInfo'>
            <div>{checkNameUser(this.state.userInfo)}</div>
          </div>

          <div className='ztab-row-button'>
            <div className='ztab-more-info_phone'>
              <span className='ztab-more-info_phone-txt'></span>
              <span className='ztab-more-info_phone_number'></span>
            </div>

            {(rxaget(userInfo, 'id', '') !== rxaget(this.user, 'id', '')) && <div className='ztab-more-info_act '>
              <img className='icon32 ztab-icon-act filter_img_class' alt='' src={changeColorSVG('./images/default/icons/messenger.svg')} onClick={(e) => this.createNewChat(userInfo)} />
              <img className='icon32 ztab-icon-act filter_img_class' alt='' src={changeColorSVG('./images/default/icons/callright.svg')} onClick={(e) => this.onClickStartCall('voicecall', userInfo)} />
              <img className='videocall-icon ztab-icon-act filter_img_class' alt='' src={changeColorSVG('./images/default/icons/videocall.svg')} onClick={(e) => this.onClickStartCall('videocall', userInfo)} />
            </div>}
          </div>

          {(this.state.partnerProfile && this.state.partnerProfile.username !== '' && [1, 2].indexOf(this.state.partnerProfile.type) !== -1) && <div className='ztab-row-userinfo'>
            <div className='newManager_profileinfo'>
              {(this.state.partnerProfile.type === 1) && <div>
                {this.arrDefaultStaff.map((ele, index) => <div className="newManager_zgroupitem-profile clearfix" key={index}>
                  <div className="zgroupitem_profile-title">
                    {translate(ele.name)}
                  </div>
                  <div className="zgroupitem_profile-info">
                    {this.state.partnerProfile[ele.key]}
                  </div>
                </div>)}
              </div>}
              {/* {(this.state.partnerProfile.type === 2) && <div>
                {this.arrDefaultCustomer.map((ele, index) => <div className="newManager_zgroupitem-profile clearfix" key={index}>
                  <div className="zgroupitem_profile-title">
                    {translate(ele.name)}
                  </div>
                  <div className="zgroupitem_profile-info">
                    {this.state.partnerProfile[ele.key]}
                  </div>
                </div>)}
              </div>} */}
            </div>
          </div>}

        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  netaauth: state.netaauth,
  netaGroups: state.netaGroups
})

const mapDispatchToProps = {
  chooseGroupAction,
  clickCall,
  updateGroupsDraft,
  netaGroupsUpdate,
}

const RxInfoUserWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxInfoUser)

export default RxInfoUserWrapped
